var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5685_8529",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.915 0.75H12.9282V10.2649H22.915V0.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5685_8529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5477 0.729492C8.36355 0.729492 4.16064 4.9575 4.16064 10.1726C4.16064 15.3877 8.36355 19.6158 13.5477 19.6158C18.7318 19.6158 22.9348 15.3877 22.9348 10.1726C22.9348 4.9575 18.7318 0.729492 13.5477 0.729492ZM13.5001 15.6604C10.5078 15.6604 8.08192 13.2201 8.08192 10.2098C8.08192 7.19961 10.5078 4.75923 13.5001 4.75923C16.4924 4.75923 18.9184 7.19961 18.9184 10.2098C18.9184 13.2201 16.4924 15.6604 13.5001 15.6604Z",
    fill: "url(#paint0_radial_5685_8529)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.4316C0 9.56578 3.91863 5.62059 8.75457 5.61475V8.80091C5.66817 8.80679 3.16724 11.3253 3.16724 14.4316C3.16724 17.5418 5.67346 20.0625 8.76461 20.0625C11.8372 20.0625 14.362 17.5652 14.362 14.4099L17.5292 14.4125C17.5292 19.3013 13.6053 23.2487 8.76461 23.2487C3.92444 23.2487 0 19.3018 0 14.4316Z",
    fill: "#006539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89746 14.4326C4.89746 12.2729 6.63801 10.5215 8.78544 10.5215C10.9324 10.5215 12.6729 12.2729 12.6729 14.4326C12.6729 16.5924 10.9324 18.3438 8.78544 18.3438C6.63801 18.3438 4.89746 16.5929 4.89746 14.4326Z",
    fill: "#52AE32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 9.47837C11.4824 8.2404 12.48 7.23682 13.7107 7.23682C14.9413 7.23682 15.939 8.2404 15.939 9.47837C15.939 10.7169 14.9413 11.72 13.7107 11.72C12.4795 11.7206 11.4824 10.7169 11.4824 9.47837Z",
    fill: "#006539"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5685_8529",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5477 10.1727) scale(9.38708 9.44312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000256026,
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7582,
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8435,
    stopColor: "#D2C11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9217,
    stopColor: "#AAC202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    stopColor: "#9CCB12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.0af0a78ea6b5e1af896d208b1fbde5fc.svg";
export { ForwardRef as ReactComponent };